import React from 'react'
import image1 from 'assets/icons/1.svg'
import image2 from 'assets/icons/2.svg'
import image3 from 'assets/icons/3.svg'

function OurEdge() {
  return (
    <section className='flex w-full items-center justify-center bg-blue text-white'>
      <div className='my-10 flex w-11/12 flex-col items-center justify-center gap-8 md:w-10/12'>
        <header className='flex flex-col gap-2'>
          <h2 className='text-4xl font-bold md:text-5xl'>Por que somos Líder?</h2>
          <p className='w-full text-lg md:w-2/3'>
            Somos líderes em soluções financeiras, com atendimento ágil, personalizado e transparente, conquistando a
            confiança dos clientes com resultados comprovados.
          </p>
        </header>

        <ul className='grid w-full grid-cols-1 items-center justify-center gap-8 md:grid-cols-3'>
          <li className='flex w-full flex-1 flex-col gap-2 rounded-2xl bg-yellow p-6 text-black'>
            <img src={image1} alt='' className='h-16 w-16' />
            <header className='text-3xl font-bold uppercase md:text-5xl'>top 1</header>
            <p className='text-xl font-medium'>A Maior de Ivaiporã - PR e Região.</p>
          </li>
          <li className='flex w-full flex-1 flex-col gap-2 rounded-2xl bg-yellow p-6 text-black'>
            <img src={image2} alt='' className='h-16 w-16' />
            <header className='text-3xl font-bold uppercase md:text-5xl'>+5.000</header>
            <p className='text-xl font-medium'>Clientes Atendidos.</p>
          </li>
          <li className='flex w-full flex-1 flex-col gap-2 rounded-2xl bg-yellow p-6 text-black'>
            <img src={image3} alt='' className='h-16 w-16' />
            <header className='text-3xl font-bold uppercase md:text-5xl'>+10 Milhões</header>
            <p className='text-xl font-medium'>Liberados em Empréstimos.</p>
          </li>
        </ul>
      </div>
    </section>
  )
}

export default OurEdge
